// src/components/marketing/DemoSection/DemoSection.js
import React, { useState } from "react";
import styles from "./DemoSection.module.css";
import { DEMO_HTML } from "../../../content/marketingCopy";
import { useAuth } from "../../../context/AuthContext";
import { InvitationAPI } from "../../../utils/firebase";

export default function DemoSection() {
  const { user } = useAuth();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  // Hide the entire section when signed in
  if (user) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    setLoading(true);
    try {
      await InvitationAPI.submitBetaInviteRequest(email);
      setEmail("");
      setShowSuccess(true);
      // auto-hide success after 2.4s (matches your old behavior)
      window.setTimeout(() => setShowSuccess(false), 2400);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error("Invite request failed:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="demo" className="py-5" aria-labelledby="demo-heading">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 col-lg-8">
            <div className={styles.card}>
              {/* Title + description only */}
              <div dangerouslySetInnerHTML={{ __html: DEMO_HTML }} />

              {/* React-controlled form */}
              <form className="row g-2 mt-1" onSubmit={handleSubmit}>
                <div className="col-12 col-md-8">
                  <input
                    type="email"
                    className="form-control"
                    placeholder="you@example.com"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
                <div className="col-12 col-md-4 d-grid">
                  <button
                    className="btn btn-primary"
                    type="submit"
                    disabled={loading}
                    {...(loading ? { "data-loading": "true" } : {})}
                  >
                    Request Invite
                  </button>
                </div>
              </form>
            </div>

            {/* subtle, accessible success message */}
            <div
              role="status"
              aria-live="polite"
              className={`${styles.success} ${showSuccess ? styles.show : ""}`}
            >
              Thanks! We’ll email you with Public Beta invite details.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
